import http from '../../http-common'

class EventDataService {
  getSettPercent(orgId) {
    return http.get('/setting/smeta?orgId=' + orgId)
    .catch((error) => console.log(error.message));
  }

}

export default new EventDataService()
